import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../../components/common/Modal';

export default function CommunicationLog() {
  const [logs, setLogs] = useState([]);
  const [modal, setModal] = useState(false);
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ client: '', type: 'note', direction: 'outbound', content: '' });

  useEffect(() => {
    api.get('/communications').then(res => setLogs(res.data.data));
    api.get('/clients?limit=100').then(res => setClients(res.data.data.clients));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await api.post('/communications', form);
    setModal(false);
    const res = await api.get('/communications');
    setLogs(res.data.data);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <h3>Communication Logs</h3>
        <button className="btn btn-primary" onClick={() => setModal(true)}>+ Log Communication</button>
      </div>
      <div className="card">
        <div className="table-container">
          <table>
            <thead><tr><th>Date</th><th>Client</th><th>Type</th><th>Direction</th><th>Content</th><th>By</th></tr></thead>
            <tbody>
              {logs.map(l => (
                <tr key={l._id}>
                  <td className="text-xs">{new Date(l.createdAt).toLocaleString()}</td>
                  <td>{l.client?.firstName} {l.client?.lastName}</td>
                  <td><span className="badge badge-info">{l.type}</span></td>
                  <td className="text-xs">{l.direction}</td>
                  <td style={{maxWidth:'300px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{l.content}</td>
                  <td className="text-xs">{l.sentBy?.firstName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal isOpen={modal} onClose={() => setModal(false)} title="Log Communication">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Client*</label>
            <select className="form-control" required value={form.client} onChange={e => setForm({...form, client: e.target.value})}>
              <option value="">Select</option>
              {clients.map(c => <option key={c._id} value={c._id}>{c.firstName} {c.lastName}</option>)}
            </select>
          </div>
          <div className="grid grid-2 gap-1">
            <div className="form-group">
              <label>Type</label>
              <select className="form-control" value={form.type} onChange={e => setForm({...form, type: e.target.value})}>
                {['note', 'call', 'sms', 'email', 'whatsapp'].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Direction</label>
              <select className="form-control" value={form.direction} onChange={e => setForm({...form, direction: e.target.value})}>
                <option value="inbound">Inbound</option>
                <option value="outbound">Outbound</option>
              </select>
            </div>
          </div>
          <div className="form-group"><label>Content*</label><textarea className="form-control" rows="4" required value={form.content} onChange={e => setForm({...form, content: e.target.value})}></textarea></div>
          <button type="submit" className="btn btn-primary w-full">Save Log</button>
        </form>
      </Modal>
    </div>
  );
}